import Paragraph from 'components/TextComps/Paragraph';
import './FAQ.scss';
import { Subtitle } from 'components/TextComps/Subtitle';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { DefaultRoutes } from 'Routes';
import { Accordion } from '@trackman/web-shared-components';
import { useCallback, useState } from 'react';

export const FAQ = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const qna = [
    {
      q: t('HowDoISignUpToAWorkshop', { ns: 'subscriptionsAndPricing' }),
      a: <>{t('OurListOfWorkshops', { ns: 'subscriptionsAndPricing' })}</>,
    },
    {
      q: t('HowMuchDoINeedToPay', { ns: 'subscriptionsAndPricing' }),
      a: <>{t('YouPay475ForTheFirstYear', { ns: 'subscriptionsAndPricing' })}</>,
    },
    {
      q: t('ForHowLongIsTrackmanCertValid', { ns: 'subscriptionsAndPricing' }),
      a: (
        <Trans i18nKey='YourCertificationIsValidForThreeYears' ns='subscriptionsAndPricing'>
          Your Certification is valid for a period of 3 years counting from the date you passed the test. Click&nbsp;
          <span onClick={() => navigate(DefaultRoutes.LearningHub)} className='link'>
            here
          </span>
          &nbsp; to take a test.
        </Trans>
      ),
    },
    {
      q: t('WhereDoITakeTheTestForLevel', { ns: 'subscriptionsAndPricing' }),
      a: (
        <Trans i18nKey='ToTakeATest' ns='subscriptionsAndPricing'>
          To take a test for Level 1 or 2 go to Modules and Tests. If you want to apply for a Master Certification, please contact Trackman
          at&nbsp;
          <a href='mailto:master@trackmanuniversity.com'>master@trackmanuniversity.com</a>.
        </Trans>
      ),
    },
    {
      q: t('CanPgmPgaStudents', { ns: 'subscriptionsAndPricing' }),
      a: <>{t('YesWeHaveASpecialProgram', { ns: 'subscriptionsAndPricing' })}</>,
    },
    {
      q: t('DoYouHaveCollegePrograms', { ns: 'subscriptionsAndPricing' }),
      a: (
        <Trans i18nKey='YesCollegesCanEasilyLink' ns='subscriptionsAndPricing'>
          Yes. Colleges can easily link the Trackman curriculum to their online platforms including a Student Administration Tool to monitor
          progress and performance. If you want to learn more please contact us at&nbsp;
          <a href='mailto:master@trackmanuniversity.com'>master@trackmanuniversity.com</a>.
        </Trans>
      ),
    },
  ];

  const [expandedPanelIndex, setExpandedPanelIndex] = useState<number | null>(null);
  const handlePanelExpandedState = useCallback(
    (index: number) => {
      if (expandedPanelIndex === index) {
        setExpandedPanelIndex(null);
      } else {
        setExpandedPanelIndex(index);
      }
    },
    [expandedPanelIndex]
  );

  return (
    <div className='shop-faq'>
      <Subtitle>
        <>{t('FrequentlyAskedQuestions', { ns: 'subscriptionsAndPricing' })}</>
      </Subtitle>
      <Paragraph>
        <>{t('FindTheAnswers', { ns: 'subscriptionsAndPricing' })}</>
      </Paragraph>
      <div className='faq-entries'>
        {qna.map((item, index) => (
          <Accordion
            key={`faq-accordion-${index}`}
            expanded={expandedPanelIndex === index}
            onChange={() => handlePanelExpandedState(index)}
            severity='primary'
            title={item.q}
          >
            <Paragraph>
              <>{item.a}</>
            </Paragraph>
          </Accordion>
        ))}
      </div>
    </div>
  );
};
